// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M7IlegqvhpIbJdb_dn9Q{display:flex;align-items:center;position:relative;text-align:left;border-radius:var(--border-radius-sm);font-weight:500;width:100%;color:var(--app-subNavigationPanel-linkColor) !important;padding-top:var(--spacing-xxs);padding-bottom:var(--spacing-xxs);padding-right:var(--spacing-xs);padding-left:var(--spacing-xs);gap:var(--spacing-xxxs);transition:var(--transition-default)}.M7IlegqvhpIbJdb_dn9Q:not(.uXRZUn71lsV9ZZyqFavH):hover{background-color:var(--app-subNavigationPanel-linkBackgroundColor) !important;color:var(--app-navigationPanel-linkColorHover);text-decoration:none}.M7IlegqvhpIbJdb_dn9Q.active{color:var(--app-subNavigationPanel-linkColor) !important;background-color:var(--app-subNavigationPanel-linkBackgroundColor);font-weight:500;pointer-events:none;transition:var(--transition-default)}.M7IlegqvhpIbJdb_dn9Q:focus-visible{outline-offset:-2px}.M7IlegqvhpIbJdb_dn9Q:focus{text-decoration:none}.uMvmOeyvPsEShZcoM6wA{width:100%;min-width:0;align-items:center}.KdsZc4rFd48HiS5xVVCz{display:block;overflow:hidden;min-width:0;text-overflow:ellipsis;white-space:nowrap}.vKebV81kBIt73rKjirR8{flex:1;min-width:0;overflow:hidden}.b1xU8bqNCuK_jX1NQCJ9{cursor:default !important}.t35wKskfk3irKEZY1s8Z{display:flex;flex-shrink:0;pointer-events:auto}.SC9d1Iwa9LupAYHonvDp{opacity:var(--disabled-opacity);max-width:170px}`, "",{"version":3,"sources":["webpack://./src/components/navigation/navigation-panel/sub-navigation-panel/contents/navigation-sub-menu-item/navigation-sub-menu-item.scss"],"names":[],"mappings":"AAGA,sBACI,YAAA,CACA,kBAAA,CACA,iBAAA,CACA,eAAA,CACA,qCAAA,CACA,eAAA,CACA,UAAA,CACA,wDAAA,CACA,8BAAA,CACA,iCAAA,CACA,+BAAA,CACA,8BAAA,CACA,uBAAA,CACA,oCAAA,CAEA,uDACI,6EAAA,CACA,+CAAA,CACA,oBAAA,CAGJ,6BACI,wDAAA,CACA,kEAAA,CACA,eAAA,CACA,mBAAA,CACA,oCAAA,CAGJ,oCACI,mBAAA,CAGJ,4BACI,oBAAA,CAIR,sBACI,UAAA,CACA,WAAA,CACA,kBAAA,CAGJ,sBACI,aAAA,CACA,eAAA,CACA,WAAA,CACA,sBAAA,CACA,kBAAA,CAGJ,sBACI,MAAA,CACA,WAAA,CACA,eAAA,CAGJ,sBACI,yBAAA,CAGJ,sBACI,YAAA,CACA,aAAA,CAEA,mBAAA,CAGJ,sBACI,+BAAA,CACA,eAAA","sourcesContent":["@use \"~styles/size\" as size;\n@use \"~styles/theme\" as theme;\n\n.navigationMenuItem {\n    display: flex;\n    align-items: center;\n    position: relative;\n    text-align: left;\n    border-radius: var(--border-radius-sm);\n    font-weight: 500;\n    width: 100%;\n    color: var(--app-subNavigationPanel-linkColor) !important;\n    padding-top: var(--spacing-xxs);\n    padding-bottom: var(--spacing-xxs);\n    padding-right: var(--spacing-xs);\n    padding-left: var(--spacing-xs);\n    gap: var(--spacing-xxxs);\n    transition: var(--transition-default);\n\n    &:not(.asBox):hover {\n        background-color: var(--app-subNavigationPanel-linkBackgroundColor) !important;\n        color: var(--app-navigationPanel-linkColorHover);\n        text-decoration: none;\n    }\n\n    &:global(.active) {\n        color: var(--app-subNavigationPanel-linkColor) !important;\n        background-color: var(--app-subNavigationPanel-linkBackgroundColor);\n        font-weight: 500;\n        pointer-events: none;\n        transition: var(--transition-default);\n    }\n\n    &:focus-visible {\n        outline-offset: -2px;\n    }\n\n    &:focus {\n        text-decoration: none;\n    }\n}\n\n.rightAndMiddleSections {\n    width: 100%;\n    min-width: 0;\n    align-items: center;\n}\n\n.middleSection {\n    display: block;\n    overflow: hidden;\n    min-width: 0;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.tooltipTrigger {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n}\n\n.defaultCursor {\n    cursor: default !important;\n}\n\n.rightSection {\n    display: flex;\n    flex-shrink: 0;\n    // Restore hover/tooltip interaction on an active link, which sets pointer-events: none:\n    pointer-events: auto;\n}\n\n.disabled {\n    opacity: var(--disabled-opacity);\n    max-width: 170px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpointXs": `458px`,
	"breakpointSm": `580px`,
	"breakpointMd": `768px`,
	"breakpointLg": `992px`,
	"breakpointXl": `1200px`,
	"breakpointXxl": `1600px`,
	"whiteColor": `var(--color-white)`,
	"oemLicenseKeysBulkImportModal": `var(--color-grey-950)`,
	"homeViewTierTypeLabelTextColor": `var(--color-grey-500)`,
	"homeCurrentPlanRedColor": `var(--color-purple-1050)`,
	"homeCurrentPlanBlueColor": `var(--color-blue-1000)`,
	"homeCurrentPlanYellowColor": `var(--color-yellow-1000)`,
	"homeCurrentPlanIconRedColor": `var(--color-purple-800)`,
	"homeCurrentPlanIconBlueColor": `var(--color-sky-700)`,
	"homeCurrentPlanIconYellowColor": `var(--color-orange-300)`,
	"homeCardTextColor": `var(--color-grey-700)`,
	"homeCardVersionColor": `var(--color-grey-700)`,
	"homeCardBackgroundColor": `var(--color-grey-1000)`,
	"homeCardBorderColor": `var(--color-grey-950)`,
	"homeCardNameColor": `var(--color-grey-500)`,
	"homeWireIconColor": `var(--color-purple-700)`,
	"homeWireIconBackgroundColor": `var(--color-purple-300)`,
	"activeBackgroundColor": `var(--color-blue-700)`,
	"primaryButtonBackgroundColor": `var(--color-blue-700)`,
	"secondaryButtonForegroundColor": `var(--color-blue-500)`,
	"bannerBackgroundColor": `rgba(13,27,181,.5)`,
	"linkTextColor": `var(--color-blue-500)`,
	"primaryButtonBackgroundHoverColor": `var(--color-blue-800)`,
	"secondaryButtonBackgroundHoverColor": `var(--color-blue-1000)`,
	"destructiveButtonBackgroundHoverColor": `var(--color-red-900)`,
	"primaryButtonBackgroundActiveColor": `var(--color-blue-900)`,
	"destructiveButtonBackgroundColor": `var(--color-red-950)`,
	"navigationButtonBackgroundActiveColor": `var(--color-blue-1000)`,
	"chartNegativeColor": `var(--color-red-500)`,
	"chartPositiveColor": `var(--color-green-500)`,
	"chartNeutralColor": `var(--color-grey-500)`,
	"errorBackgroundColor": `var(--color-red-600)`,
	"errorBorderColor": `var(--color-red-600)`,
	"errorTextColor": `var(--color-red-600)`,
	"deleteScheduleLinkColor": `#db2828`,
	"errorWrapperBackgroundColor": `var(--color-red-400)`,
	"warningBackgroundColor": `var(--color-orange-800)`,
	"warningTextColor": `var(--color-orange-800)`,
	"secondaryWarningBackgroundColor": `var(--color-yellow-700)`,
	"secondaryWarningBorderColor": `var(--color-yellow-700)`,
	"successBorderColor": `var(--color-green-500)`,
	"successTextColor": `var(--color-green-500)`,
	"pageBackgroundColor": `var(--color-grey-1000)`,
	"wrapperBackgroundColor": `var(--color-blue-200)`,
	"urlSectionBackgroundColor": `var(--color-blue-900)`,
	"wrapperBorderColor": `var(--color-blue-500)`,
	"modelBoxBackgroundColor": `var(--color-grey-900)`,
	"contentBackgroundColor": `var(--color-grey-1000)`,
	"secondaryButtonBackgroundColor": `var(--color-grey-950)`,
	"textColor": `var(--color-white)`,
	"textGreyColor": `var(--color-grey-700)`,
	"primaryButtonForegroundColor": `var(--color-white)`,
	"bannerForegroundColor": `var(--color-grey-900)`,
	"chartOutlineColor": `var(--color-grey-1000)`,
	"modalOverlayColor": `rgba(33,32,32,.4)`,
	"contentDividerColor": `var(--color-grey-1000)`,
	"contentBorderColor": `var(--color-grey-1000)`,
	"nestedContentBorderColor": `var(--color-grey-500)`,
	"disabledButtonBackgroundColor": `var(--color-grey-500)`,
	"disabledButtonForegroundColor": `var(--color-grey-900)`,
	"inputHintColor": `var(--color-grey-500)`,
	"inputBackgroundColor": `var(--color-grey-900)`,
	"hoverBackgroundColor": `var(--color-grey-1000)`,
	"toggleCheckedBackgroundColor": `var(--color-blue-500)`,
	"toggleUncheckedBackgroundColor": `var(--color-grey-500)`,
	"chartFirstSet": `#708add`,
	"chartSecondSet": `#dd75a0`,
	"chartThirdSet": `#4a7ab6`,
	"chartForthSet": `#5f96bc`,
	"chartFifthSet": `#c4874a`,
	"chartSixthSet": `#b63e5c`,
	"chartSeventhSet": `#6c8fa9`,
	"chartEighthSet": `#f3a14e`,
	"chartNinthSet": `#88bbdb`,
	"chartTenthSet": `#e2afc3`,
	"chartEleventhSet": `#b1bfde`,
	"chartTwelfthSet": `#facf96`,
	"optional": `var(--color-white)`,
	"disabledTextColor": `var(--color-grey-900)`,
	"colorPickerBlack": `var(--color-grey-1000)`,
	"iconFillColor": `var(--theme-icon-fill-default)`,
	"sortIconRegularColor": `var(--color-grey-500)`,
	"sortIconHoverColor": `var(--color-blue-500)`,
	"sortIconActiveColor": `var(--color-white)`,
	"diamondTierBannerBorderColor": `var(--color-pink-700)`,
	"starTierBannerBorderColor": `var(--color-purple-900)`,
	"chartSuccessColor": `var(--color-green-600)`,
	"chartFailColor": `var(--color-red-800)`,
	"textFieldColor": `var(--color-grey-1000)`,
	"focusOutlineColorButton": `#d661e5`,
	"tooltipTextColor": `var(--color-grey-900)`,
	"tooltipBackgroundColor": `var(--color-grey-150)`,
	"chipBackgroundColor": `var(--color-grey-900)`,
	"chipContentColor": `var(--color-white)`,
	"chipUserIconColor": `var(--color-grey-1000)`,
	"successIconColor": `var(--color-green-500)`,
	"errorIconColor": `var(--color-red-500)`,
	"localBannerBackgroundColor": `var(--color-blue-1000)`,
	"localBannerBorderColor": `var(--color-grey-950)`,
	"errorBannerBackgroundColor": `var(--color-red-300)`,
	"localBannerTextColor": `var(--color-white)`,
	"successBadgeTextColor": `var(--color-green-200)`,
	"warningBadgeBackgroundColor": `var(--color-yellow-600)`,
	"warningBadgeTextColor": `var(--color-yellow-900)`,
	"errorBadgeBackgroundColor": `var(--color-red-950)`,
	"errorBadgeTextColor": `var(--color-white)`,
	"infoBadgeBackgroundColor": `var(--color-blue-800)`,
	"infoBadgeTextColor": `var(--color-white)`,
	"infoIconBackgroundColor": `var(--color-grey-150)`,
	"neutralBadgeBackgroundColor": `var(--color-grey-800)`,
	"neutralBadgeTextColor": `var(--color-white)`,
	"strokeColor": `var(--color-blue-900)`,
	"textHighlightForegroundColor": `linear-gradient(0deg, rgba(250, 200, 16, 0.3) 0%, rgba(250, 200, 16, 0.3) 100%)`,
	"textHighlightBackgroundColor": `var(--color-white)`,
	"skeletonLoaderBackgroundColor": `var(--color-grey-1000)`,
	"fourthLevelTierBackgroundColor": `var(--color-purple-900)`,
	"defaultStarColor": `var(--color-green-800)`,
	"addOnsCheckmarkColor": `var(--color-green-500)`,
	"warningBannerBackgroundColor": `var(--color-yellow-600)`,
	"warningBannerBorderColor": `var(--color-yellow-150)`,
	"warningBannerTextColor": `var(--color-grey-1000)`,
	"warningIconBackgroundColor": `var(--color-grey-1000)`,
	"warningIconExclamationColor": `var(--color-yellow-700)`,
	"hoverColor": `rgba(var(--color-blue-700), 0.3)`,
	"navigationButtonBackgroundHoverColor": `var(--color-blue-1000)`,
	"conditionToggleButtonBackgroundColor": `var(--color-grey-1000)`,
	"conditionToggleButtonBorderColor": `var(--color-grey-900)`,
	"conditionTableBackgroundColor": `var(--color-grey-1000)`,
	"conditionTableBorderColor": `var(--color-grey-900)`,
	"conditionTableNestedBackgroundColor": `var(--color-grey-1000)`,
	"modularPurpleColor": `var(--color-purple-600)`,
	"modularBackgroundPurpleColor": `var(--color-purple-1000)`,
	"readyToUseSkyBlueColor": `var(--color-sky-600)`,
	"readyToUseBackgroundBlueColor": `var(--color-blue-1000)`,
	"readyToUseBorderBlueColor": `var(--color-sky-900)`,
	"modularBorderPurpleColor": `var(--color-purple-950)`,
	"integrationGreenColor": `var(--color-green-400)`,
	"integrationBorderGreenColor": `var(--color-green-900)`,
	"integrationBackgroundGreenColor": `var(--color-green-950)`,
	"descriptionTextColor": `var(--color-grey-700)`,
	"lightGreenBackgroundColor": `var(--color-green-200)`,
	"lightBlueBackgroundColor": `var(--color-blue-200)`,
	"errorBannerColor": `var(--color-red-300)`,
	"errorBannerTextColor": `var(--color-grey-900)`,
	"bannerIconBackgroundColor": `var(--color-red-800)`,
	"bannerIconColor": `var(--color-white)`,
	"accordianSuccessBackgroundColor": `var(--color-green-950)`,
	"accordianSuccessBorderColor": `var(--color-green-950)`,
	"accordianSuccessTextColor": `var(--color-green-500)`,
	"cardBorderColor": `var(--color-grey-900)`,
	"navigationListDividerColor": `var(--color-grey-900)`,
	"userDefinedErrorColor": `var(--color-orange-950)`,
	"ruleGreenColor": `#096442`,
	"ruleYellowColor": `#987100`,
	"ruleBlueColor": `#0156a6`,
	"ruleRedColor": `#a51313`,
	"rulePurpleColor": `#453498`,
	"ruleOrangeColor": `#ca5600`,
	"rulePinkColor": `#c41796`,
	"ruleCyanColor": `#006e80`,
	"ruleGrayColor": `#646262`,
	"defaultTheme": `defaultTheme`,
	"tenantTheme": `tenantTheme`,
	"defaultDarkTheme": `defaultDarkTheme`,
	"tenantDarkTheme": `tenantDarkTheme`,
	"subTenantTheme": `subTenantTheme`,
	"subTenantDarkTheme": `subTenantDarkTheme`,
	"navigationMenuItem": `M7IlegqvhpIbJdb_dn9Q`,
	"asBox": `uXRZUn71lsV9ZZyqFavH`,
	"rightAndMiddleSections": `uMvmOeyvPsEShZcoM6wA`,
	"middleSection": `KdsZc4rFd48HiS5xVVCz`,
	"tooltipTrigger": `vKebV81kBIt73rKjirR8`,
	"defaultCursor": `b1xU8bqNCuK_jX1NQCJ9`,
	"rightSection": `t35wKskfk3irKEZY1s8Z`,
	"disabled": `SC9d1Iwa9LupAYHonvDp`
};
export default ___CSS_LOADER_EXPORT___;
